import React from 'react';
import {withRouter} from 'react-router-dom';
import { Declaration } from 'components/importExport/declaration/Declaration';
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import {saveImportExportApplication} from "../../../redux/actions";
import { useDispatch } from "react-redux";


const OrganisationDeclaration = props => {

  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);

  const dispatch = useDispatch();  

  const continueButtonHandler = () => {

    props.history.push('./organisation-fee-breakdown')  
       
  }

  const saveApplication = () => {

    dispatch(
      saveImportExportApplication("", () => {
          props.history.push(`./organisation-dashboard`);
      })
    );           
  }


  return (

    <Declaration props={props} continueButtonHandler={continueButtonHandler} saveApplication={saveApplication}/>

  )
};
  
  export default withRouter(props => <OrganisationDeclaration {...props}/>);
  
